import Alpine from "alpinejs";

let select = [];

Alpine.data("articlesNewestTeaserHover", () => ({
    hover: false,
    headlineLink: {
        ["@mouseenter"]() {
            this.hover = true;
        },
        ["@focus"]() {
            this.hover = true;
        },
        ["@mouseleave"]() {
            this.hover = false;
        },
        ["@blur"]() {
            this.hover = false;
        },
    },
    footerLink: {
        [":class"]() {
            return this.hover && "underline";
        },
    },
}));
